<template>
  <q-btn
    clickable
    round
    v-ripple
    class="bg-primary text-white"
    name="record"
    :size="mobile ? 'lg' : 'sm'"
    @click="() => {
      if (recordStatus.status === 'RECORDING' && recordStatus.caller === 'RECORD_WIDGET') {
        store.commit('setRecordingWidget', true);
      } else if(mobile) {
        toggleRecordWidget();
      }
    }
    "
  >
    <q-menu
      :cover="isMobile"
      :anchor="isMobile ? 'center middle' : undefined"
      :self="isMobile ? 'bottom middle' : undefined"
      :class="{ 'full-width': isMobile }"
      v-if="(recordStatus.status === 'NONE' || recordStatus.caller !== 'RECORD_WIDGET') && !isMobile"
    >
      <q-list class="full-width" :class="{ 'q-gutter-y-sm q-py-sm': isMobile }">
        <MenuItem
          label="Record Audio"
          @click="toggleRecordWidget"
          :disable="recordStatus.status !== 'NONE' && recordStatus.caller !== 'RECORD_WIDGET'"
        >
          <q-icon size="xs" :name="tabOutlineMicrophone" />
        </MenuItem>
        <UploadAudio />
        <MenuItem label="Google Meets" @click="openRequestBotModal">
          <q-icon size="xs" :name="tabOutlineRobotFace" />
        </MenuItem>
      </q-list>
    </q-menu>

    <q-icon
      :size="mobile ? 'md' : 'xs'"
      :name="
        recordStatus.status === 'RECORDING' && recordStatus.caller === 'RECORD_WIDGET'
          ? tabPlayerStopFilled
          : tabOutlineMicrophone
      "
    />
    <q-badge
      v-if="recordStatus.status !== 'NONE' && recordStatus.caller === 'RECORD_WIDGET'"
      color="accent"
      rounded
      class="absolute-top-right q-pa-xs"
      style="width: 12px; height: 12px; "
    >
      <q-spinner-puff
        color="accent"
        class="absolute-center"
        size="36px"
        v-if="recordStatus.status === 'RECORDING' && recordStatus.caller === 'RECORD_WIDGET'"
      />
    </q-badge>
  </q-btn>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useQuasar } from 'quasar';

import { tabOutlineMicrophone, tabOutlineRobotFace } from 'quasar-extras-svg-icons/tabler-icons-v3';
import { tabPlayerStopFilled } from 'quasar-extras-svg-icons/tabler-icons-v2';

import MenuItem from '@/components/brand/MenuItem.vue';
import UploadAudio from './UploadAudio.vue';
import RequestBotModal from '@/components/modals/RequestBotModal.vue';
import { useMobile } from '@/hooks/useMobile';
import { SendError } from '@/helpers';

const { dialog } = useQuasar();
const store = useStore();
const { isMobile } = useMobile();

defineProps({
  withText: {
    type: Boolean,
    default: true,
  },
  mobile: {
    type: Boolean,
    default: false,
  },
});

const recordStatus = computed(() => store.state.recordStatus);

const toggleRecordWidget = async () => {
  try {
    await store.dispatch('recordAudio');
  } catch (error) {
    console.error('toggleRecordWidget', error);
    SendError('Something went wrong please try again later');
  }
};

const openRequestBotModal = () => {
  dialog({
    component: RequestBotModal,
  });
};
</script>
